module.exports = __webpack_public_path__ + "img/9788991931527.54b04e98.jpg";